<template>
  <Modal
    cancel-variant="primary"
    confirm-variant="primary-ghost"
    data-testid="lottery-play-slip-navbar-incomplete-plays-modal"
    :tracking="{
      action: 'checkout',
      topicKey: 'incomplete-plays-confirmation',
    }"
    @cancel="emit('cancel')"
    @confirm="emit('confirm')"
  >
    <template #headline>
      <slot :plays-to-review="count" name="headline">
        {{ $t('lottery.playslipnavbar.modal.incompleteplays.headline', count) }}
      </slot>
    </template>

    <template #cancel>
      <slot name="cancel">
        {{ $t('lottery.playslipnavbar.modal.incompleteplays.cancel') }}
      </slot>
    </template>

    <template #confirm>
      <slot name="confirm">
        {{ $t('lottery.playslipnavbar.modal.incompleteplays.confirm') }}
      </slot>
    </template>

    <slot name="message">
      {{ $t('lottery.playslipnavbar.modal.incompleteplays.message') }}
    </slot>
  </Modal>
</template>

<script lang="ts" setup>
defineProps<{ count: number }>()
const emit = defineEmits<{ (e: 'cancel' | 'confirm'): void }>()
</script>
